module.exports = __webpack_public_path__ + "img/logo-dark.b8f650de.png";